import React from "react";
import "./PassionInfo.css";

const PassionInfo = () => {
  return (
    <div className="uigrid-6 passion-content-container">
      <div className="passion-section-header">
        <h1>Commerce</h1>
        <h1>software</h1>
      </div>
      <div className="passion-description">
        Awa Digital builds and runs commerce software for restaurants, cloud
        kitchens, and merchants.
      </div>
    </div>
  );
};

export default PassionInfo;
